export default __webpack_public_path__ + "static/media/8-10-v2.f6de80b3.png";